'use client'

import { SignIn, useAuth } from '@clerk/nextjs'
import Link from 'next/link'
import styled from 'styled-components'

import { NextPageWithLayout } from '../../../types/NextPageWithLayout'

import {
  AuthPage,
  ClerkStyling,
} from '@/components/auth-components/ClerkGlobalStyling'
import { Card } from '@/components/shared-components/BUI/Card'
import { Text } from '@/components/shared-components/BUI/Text'
import { useRouterParams } from '@/hooks/useRouterParams'
import { ClerkAuthLayout } from '@/layouts/SimpleAuthLayout'

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const CardContainer = styled.div`
  width: 462px;
`

type Params = {
  redirectTo?: string
  emailAddress?: string
}

const SignInPage: NextPageWithLayout = () => {
  const { redirectTo, emailAddress } = useRouterParams<Params>()
  const { isLoaded } = useAuth()

  return (
    <AuthPage loading={!isLoaded}>
      <ClerkStyling />
      <PageContainer>
        <CardContainer>
          <Card bordered={false}>
            <SignIn
              routing="hash" // required so the query params are not lost
              appearance={{
                layout: {
                  logoPlacement: 'none',
                },
              }}
              forceRedirectUrl={redirectTo?.length > 0 ? redirectTo : undefined}
              initialValues={
                emailAddress
                  ? { emailAddress: decodeURIComponent(emailAddress) }
                  : undefined
              }
            />
            <Text variant="label02" mt="3rem" align="center" mb="1rem">
              <Link href="/forgot-password">Reset your password</Link>
            </Text>
          </Card>
        </CardContainer>
      </PageContainer>
    </AuthPage>
  )
}

SignInPage.getLayout = ClerkAuthLayout

export default SignInPage
